export namespace RoundHistoryState {
    export const featureKey: string = "round-history";
}

export interface IRoundHistoryState {
    roundCoefficients: number[];
}
